export default __webpack_public_path__ + "static/media/plurable.3b761f42.png";